<template>
  <div v-if="isOpen">
    <div class="modal fade" role="dialog" ref="extraModal">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-body repricing-modal">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex justify-end items-center">
                  <!-- <h4>Passenger No Show / Cancelled</h4> -->
                  <button
                    type="button"
                    class="close btn-close-modal"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <i class="ic-close"></i>
                  </button>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="evidence-contact-wrapper" style="margin-top: 20px">
                  <h4 class="title-evidence">
                    1. Evidence of attempts to contact pax
                  </h4>
                  <p class="subtitile-evidence">
                    Upload a screenshot of your attempts to contact the
                    passenger.
                  </p>

                  <label
                    class="input-file"
                    :for="
                      evidenceContactPaxList.length
                        ? 'input-evidence-contact-disable'
                        : 'input-evidence-contact'
                    "
                  >
                    <img
                      :class="
                        evidenceContactPaxList.length &&
                        previewContactPax &&
                        'preview-active'
                      "
                      :src="
                        evidenceContactPaxList.length && previewContactPax
                          ? previewContactPax.imagePreview
                          : '/static/assets/images/input-file.png'
                      "
                      alt="upload-image"
                    />
                  </label>
                  <input
                    type="file"
                    id="input-evidence-contact"
                    accept=".jpg,.jpeg,.png"
                    v-on:change="uploadEvidence($event.target.files, 1)"
                    multiple
                  />

                  <div class="img-review-wrapper">
                    <label
                      for="input-evidence-contact"
                      class="img-item upload-images"
                      v-if="
                        evidenceContactPaxList.length &&
                        evidenceContactPaxList.length !== 5
                      "
                    >
                      +
                    </label>
                    <div
                      v-for="(img, key) in evidenceContactPaxList"
                      :key="key"
                      @click="setPreviewContactImage(img, 1)"
                      :class="
                        img.id === previewContactPax.id
                          ? 'img-item active'
                          : 'img-item'
                      "
                    >
                      <img :src="img.imagePreview" :alt="img.id" />
                      <button
                        class="btn-delete-img"
                        @click="deleteImagePreview(img.id, 1)"
                      >
                        X
                      </button>
                    </div>
                    <p class="max-img-notes">You can upload up to 5 images.</p>
                  </div>
                </div>

                <div class="evidence-vehicle-wrapper">
                  <h4 class="title-evidence">
                    2. Evidence of your vehicle on location
                  </h4>
                  <p class="subtitile-evidence">
                    Photo of your vehicle on the site with time stamp and
                    location.
                  </p>
                  <label
                    class="input-file"
                    :for="
                      evidenceVehicleList.length
                        ? 'input-evidence-vehicle-disable'
                        : 'input-evidence-vehicle'
                    "
                  >
                    <img
                      :class="
                        evidenceVehicleList.length &&
                        previewVehicle &&
                        'preview-active'
                      "
                      :src="
                        evidenceVehicleList.length && previewVehicle
                          ? previewVehicle.imagePreview
                          : '/static/assets/images/input-file.png'
                      "
                      alt="upload-image"
                    />
                  </label>
                  <input
                    type="file"
                    id="input-evidence-vehicle"
                    accept=".jpg,.jpeg,.png"
                    @change="uploadEvidence($event.target.files, 2)"
                    multiple
                  />

                  <div class="img-review-wrapper">
                    <label
                      for="input-evidence-vehicle"
                      class="img-item upload-images"
                      v-if="
                        evidenceVehicleList.length &&
                        evidenceVehicleList.length !== 5
                      "
                    >
                      +
                    </label>
                    <div
                      v-for="(img, key) in evidenceVehicleList"
                      :key="key"
                      @click="setPreviewContactImage(img, 2)"
                      :class="
                        img.id === previewVehicle.id
                          ? 'img-item active'
                          : 'img-item'
                      "
                    >
                      <img :src="img.imagePreview" :alt="img.id" />
                      <button
                        class="btn-delete-img"
                        @click="deleteImagePreview(img.id, 2)"
                      >
                        X
                      </button>
                    </div>
                    <p class="max-img-notes">You can upload up to 5 images.</p>
                  </div>
                </div>

                <div class="description-wrapper">
                  <label class="input-std" for="description">
                    Description
                  </label>
                  <textarea
                    name="description"
                    id="description"
                    cols="30"
                    rows="10"
                    class="form-control"
                    placeholder="Provide more details about the situation."
                    v-model="data.notes"
                  ></textarea>
                </div>

                <div class="confirm-btn-wrapper">
                  <button
                    class="btn btn-submit"
                    style="width: 100%"
                    :disabled="!enabledConfirmBtn"
                    @click="confirmPaxNoShow()"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <loader :content="msg" :visible="isLoading" />
  </div>
</template>
<script>
import tripLogJobService from "@/services/job/tripLogJob/tripLogJobService.js";

export default {
  data() {
    return {
      isOpen: false,
      isLoading: false,
      msg: "Please wait",
      reservationId: null,
      limitEvidence: 0,
      evidenceContactPaxList: [],
      previewContactPax: null,
      previewVehicle: null,
      evidenceVehicleList: [],
      data: {
        id: "",
        notes: "",
        evidences: {
          attemptToContactPax: [],
          vehicleOnLocation: [],
        },
      },
    };
  },
  computed: {
    enabledConfirmBtn() {
      return (
        this.evidenceContactPaxList.length >= 1 &&
        this.evidenceVehicleList.length >= 1 &&
        this.data.notes
      );
    },
  },
  created() {
    this.$eventBus.$on("PaxNoShow", this.initialize);
  },
  beforeDestroy() {
    this.$eventBus.$off("PaxNoShow");
  },
  methods: {
    setPreviewContactImage(item, type) {
      if (type === 1) {
        this.previewContactPax = item;
      } else {
        this.previewVehicle = item;
      }
    },
    initialize(payload) {
      this.isOpen = true;
      this.isLoading = true;

      this.data = {
        notes: "",
        evidences: {
          attemptToContactPax: [],
          vehicleOnLocation: [],
        },
        id: payload.uuid,
      };
      this.evidenceContactPaxList = [];
      this.evidenceVehicleList = [];
      this.reservationId = payload.reservationId;

      setTimeout(() => {
        $(this.$refs.extraModal).modal({
          backdrop: "static",
          keyboard: false,
        });
        this.isLoading = false;
      }, 500);
    },
    deleteImagePreview(id, type) {
      if (type === 1) {
        this.data.evidences.attemptToContactPax =
          this.data.evidences.attemptToContactPax.filter((val) => val !== id);
        this.evidenceContactPaxList = this.evidenceContactPaxList.filter(
          (val) => val.id !== id
        );
      } else {
        this.data.evidences.vehicleOnLocation =
          this.data.evidences.vehicleOnLocation.filter((val) => val !== id);
        this.evidenceVehicleList = this.evidenceVehicleList.filter(
          (val) => val.id !== id
        );
      }
    },
    async uploadEvidence(files, type) {
      // for (const file of files) {
      //   if (file.type === "application/pdf") {
      //     console.error(`File ${file.name} tidak boleh PDF!`);
      //     alert(`Upload gagal: ${file.name} bertipe PDF`);
      //     return;
      //   }
      // }

      this.isLoading = true;
      try {
        if (type === 1) {
          const limit = 5 - this.evidenceContactPaxList.length;
          this.limitEvidence =
            this.evidenceContactPaxList.length === 0 && files.length >= 5
              ? 5
              : this.evidenceContactPaxList.length === 0 && files.length < 5
              ? files.length
              : files.length > limit
              ? limit
              : files.length;
        } else {
          const limit = 5 - this.evidenceVehicleList.length;
          this.limitEvidence =
            this.evidenceVehicleList.length === 0 && files.length >= 5
              ? 5
              : this.evidenceContactPaxList.length === 0 && files.length < 5
              ? files.length
              : files.length > limit
              ? limit
              : files.length;
        }

        for (let index = 0; index < this.limitEvidence; index++) {
          if (files[index].type === "application/pdf") {
            this.$notification.error(
              `Can't upload pdf file (${files[index].name})`,
              { title: "Error" }
            );
          } else {
            let formData = new FormData();
            formData.append("refferalId", this.data.id);
            formData.append("category", type);
            formData.append("file", files[index]);

            const response = await tripLogJobService.uploadEvidencePaxNoShow(
              this.reservationId,
              formData
            );

            if (response.isSuccess) {
              if (type === 1) {
                this.data.evidences.attemptToContactPax.push(response.data);
                this.evidenceContactPaxList.push({
                  imagePreview: URL.createObjectURL(files[index]),
                  id: response.data,
                });
                this.previewContactPax = {
                  imagePreview: URL.createObjectURL(files[index]),
                  id: response.data,
                };
              } else {
                this.data.evidences.vehicleOnLocation.push(response.data);
                this.evidenceVehicleList.push({
                  imagePreview: URL.createObjectURL(files[index]),
                  id: response.data,
                });
                this.previewVehicle = {
                  imagePreview: URL.createObjectURL(files[index]),
                  id: response.data,
                };
              }
            }
          }
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmPaxNoShow() {
      this.$emit("confirm", this.data);
      this.isOpen = false;
      $(this.$refs.extraModal).modal("hide");
    },
  },
};
</script>
<style scoped>
.modal-body.repricing-modal {
  padding: 15px 20px;
}
.btn.btn-submit {
  background: #4fb848;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}
.btn.btn-cancel {
  background: #a0a0a0;
  font-size: 0.8667rem;
  border-radius: 5px;
  border: transparent;
  font-weight: 900;
  -webkit-box-shadow: 0px 2px 8px -5px #4c4c4c;
  -moz-box-shadow: 0px 2px 8px -5px #4c4c4c;
  box-shadow: 0px 2px 8px -5px #4c4c4c;
  color: #fff;
  padding: 10px 20px;
  text-transform: uppercase;
  outline: none;
}
.btn.btn-submit:hover {
  background: #339c2b;
}
.btn.btn-cancel:hover {
  background: #888888;
}
.gap-10 {
  gap: 10px;
}

.evidence-vehicle-wrapper,
.description-wrapper,
.confirm-btn-wrapper {
  margin-top: 40px;
}

h4.title-evidence {
  font-weight: 700;
}

p.subtitile-evidence {
  font-size: 14px;
  font-weight: 300;
  line-height: 16.8px;
}

.input-file {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #edf6ec;
  width: 100%;
  height: 160px;
  border-radius: 6px;
  cursor: pointer;
}

.input-file .preview-active {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.input-std {
  font-size: 18px;
  font-weight: 700;
  line-height: 21.6px;
}

#input-evidence-contact,
#input-evidence-vehicle {
  display: none;
}

.img-review-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
}

.img-review-wrapper > .img-item {
  position: relative;
  width: 55px;
  height: 60px;
  background: #edf6ec;
  border-radius: 6px;
  overflow: hidden;
  border: 0.5px solid rgb(160, 160, 160);
}

.img-review-wrapper > .img-item.active {
  border: 2px solid #d2f5ce;
}

.img-review-wrapper > .img-item > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.img-review-wrapper > .img-item.upload-images {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #edf6ec;
  color: #000;
  font-size: 30px;
  font-weight: 700;
  border: none;
  cursor: pointer;
}

button.btn-delete-img {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  font-size: 10px;
  top: 0;
  right: 0;
  height: 18px;
  width: 18px;
  border-radius: 50%;
  background: #676666;
  color: #fff;
}

button.btn-delete-img:hover {
  background: #373737;
}

.max-img-notes {
  width: 100%;
  font-size: 14px;
  font-weight: 300;
  line-height: 16.8px;
  font-style: italic;
}

.max-img-notes::before {
  content: "* ";
}
</style>



// WEBPACK FOOTER //
// src/components/shared/PaxNoShow.vue